import React, { forwardRef, Ref } from 'react';
import { FormGroup, FormRadio } from '@spotify-internal/encore-web';
import { FieldController } from 'client/shared/FieldController';
import {
  FieldRadioToggleProps,
  ControlledFieldRadioToggleProps,
} from './types';

export const FieldRadioToggle = forwardRef(
  (
    {
      label,
      name,
      options,
      disabled,
      onChange,
      value,
      containerClassName,
      ...rest
    }: FieldRadioToggleProps,
    ref: Ref<HTMLInputElement>
  ) => (
    <FormGroup inline label={label} className={containerClassName}>
      {options.map((option, index) => {
        const { value: optionValue, label: optionLabel } = option;
        return (
          <FormRadio
            {...rest}
            ref={ref}
            id={`${name}_${index}`}
            name={name}
            disabled={disabled}
            onChange={disabled ? () => null : onChange}
            value={optionValue}
            type="radio"
            checked={value === optionValue}
          >
            {optionLabel}
          </FormRadio>
        );
      })}
    </FormGroup>
  )
);

export const ControlledFieldRadioToggle = (
  props: ControlledFieldRadioToggleProps
) => (
  <FieldController<FieldRadioToggleProps, HTMLInputElement>
    as={FieldRadioToggle}
    {...props}
  />
);
